import { SVGProps } from 'react';
interface SVGRProps {
    title?: string;
    titleId?: string;
}
export const IconCalendarPin = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={20}
        height={20}
        fill="none"
        viewBox="0 0 24 24"
        display="block"
        aria-labelledby={titleId}
        {...props}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h1a3 3 0 0 1 3 3v4a1 1 0 0 1-1 1H5v7a1 1 0 0 0 1 1h6.5a1 1 0 1 1 0 2H6a3 3 0 0 1-3-3V7a3 3 0 0 1 3-3h1V3a1 1 0 0 1 1-1M7 6H6a1 1 0 0 0-1 1v3h14V7a1 1 0 0 0-1-1h-1v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0zm9.778 8.674a4 4 0 0 1 5.05 6.154c-.396.397-1.135 1.049-2.182 1.935a1 1 0 0 1-1.288.004c-.998-.836-1.734-1.486-2.186-1.939m-.001 0a4 4 0 0 1 .607-6.154M19 15.999a2 2 0 0 0-1.414 3.415h.001c.294.296.76.718 1.41 1.274.693-.596 1.16-1.017 1.416-1.273l.001-.001A2 2 0 0 0 19 15.999M19 17a1 1 0 0 1 1 1v.01a1 1 0 1 1-2 0V18a1 1 0 0 1 1-1"
            clipRule="evenodd"
        />
    </svg>
);
